export const Circles = [
    { label: "Coptic Orthodox Church", target: "church" },
    { label: "Diocese of Southern USA", target: "diocese" },
    { label: "Archangel Michael Parish", target: "parish" },
    { label: "On Michael the Archangel", target: "archangel" },
    { label: "Clergy at Archangel Michael", target: "priest" },
];

